import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/icons/cancel.svg'
import _imports_1 from '../assets/glyphs/Air.svg'
import _imports_2 from '../assets/icons/plus-circle.svg'


const _withScopeId = n => (_pushScopeId("data-v-4bc1319c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "holder" }
const _hoisted_2 = { class: "operator" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "flip"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_6 = { class: "hand" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "flex-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]

import { getFancyActuator } from '../utils'
import { ref, computed } from 'vue'


export default {
  __name: 'ActuatorInput',
  props: {
  modelValue: { },
  canDestroy: { type: Boolean, default: false }
},
  emits: ['update:modelValue', 'close', 'destroy'],
  setup(__props, { emit: emits }) {

const props = __props;





const actuators = computed({
  get () {
    return props.modelValue
  },
  set (value) {
    emits('update:modelValue', value)
  }
})

const customV = ref('')
const fancyActuator = ref('')

function addMode (x) {
  if (actuators.value.length === 0) return

  const lastAct = actuators.value[actuators.value.length - 1]
  if (x === '|') {
    if (lastAct.length > 1) { // [["a", "b"]] -> [["a", "b"], []] or [[""a", ""]] -> [["a"], []]
      const lastFinger = lastAct[lastAct.length - 1]
      if (lastFinger.length === 0) {
        lastAct.pop()
      }
      actuators.value.push([''])
    } else if (lastAct.length === 1) {
      actuators.value.push([''])
    }
  } else if (x === '||') {
    if (lastAct.length === 0 || (lastAct.length === 1 && lastAct[0].length === 0)) {
      actuators.value.pop()
      actuators.value[actuators.value.length - 1].push('')
    } else {
      lastAct.push('')
    }
  }
  setFancyActuator()
}

function setFancyActuator () {
  fancyActuator.value = getFancyActuator(actuators.value)
}

function addActuator (finger) {
  if (actuators.value.length === 0) {
    actuators.value.push([finger])
  } else {
    const lastValue = actuators.value[actuators.value.length - 1]
    if (lastValue.length) {
      actuators.value[actuators.value.length - 1][lastValue.length - 1] = finger
    } else {
      lastValue.push(finger)
    }
  }
  setFancyActuator()
}

function removeActuator () {
  const lastValue = actuators.value[actuators.value.length - 1]
  if (lastValue.length > 1) {
    const l = lastValue.pop()
    if (l.length) lastValue.push('')
  } else if (lastValue.length === 1 && lastValue[0].length > 0) {
    lastValue[0] = ''
  } else {
    actuators.value.pop()
  }
  setFancyActuator()
}

return (_ctx, _cache) => {
  const _component_unicon = _resolveComponent("unicon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "close",
      onClick: _cache[0] || (_cache[0] = $event => {emits('input', _unref(actuators)); emits('close')})
    }, [
      _createVNode(_component_unicon, { name: "times-circle" })
    ]),
    _createTextVNode(" " + _toDisplayString(fancyActuator.value) + " ", 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "round-button",
        onClick: _cache[1] || (_cache[1] = $event => (addMode('|')))
      }, " | "),
      _createElementVNode("div", {
        class: "round-button",
        onClick: _cache[2] || (_cache[2] = $event => (addMode('||')))
      }, " || "),
      _createElementVNode("span", { onClick: removeActuator }, _hoisted_4)
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['thumb', 'index', 'middle', 'ring', 'pinky'], (finger) => {
        return _createElementVNode("img", {
          key: `${finger}-air`,
          src: _imports_1,
          class: _normalizeClass(finger),
          onClick: $event => (addActuator(finger))
        }, null, 10, _hoisted_7)
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_8, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((customV).value = $event)),
        placeholder: "Custom value"
      }, null, 512), [
        [_vModelText, customV.value]
      ]),
      _createElementVNode("div", {
        onClick: _cache[4] || (_cache[4] = $event => (addActuator(customV.value)))
      }, _hoisted_10)
    ]),
    (__props.canDestroy)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "destroy-button",
          onClick: _cache[5] || (_cache[5] = $event => {emits('destroy'); emits('close')})
        }, [
          _createVNode(_component_unicon, { name: "trash-alt" })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

}